/**
 * Module-level dedup window for error toasts. Both useApiError (React-side)
 * and the global MutationCache fallback (non-React) share this map so that a
 * caller-handled error doesn't get double-toasted by the global fallback.
 */
const recent = new Map<string, number>();
const WINDOW_MS = 5000;

/**
 * Returns true if a toast with this key was emitted within the last 5 seconds
 * (i.e. the caller should suppress its toast). Always records the current
 * timestamp under the key, so the *first* call wins and subsequent ones dedup.
 */
export const shouldDedupToast = (key: string): boolean => {
  const now = Date.now();
  const last = recent.get(key);
  if (last !== undefined && now - last < WINDOW_MS) {
    return true;
  }
  recent.set(key, now);
  if (recent.size > 50) {
    for (const [k, t] of recent) {
      if (now - t >= WINDOW_MS) recent.delete(k);
    }
  }
  return false;
};
